module.exports = __webpack_public_path__ + "img/IMG_5893.553c80ad.jpg";